import { BigInfoIcon, Flex, IconName } from "@theorgchartdev/storybook";
import UpgradeButtons from "./UpgradeButtons";
import { PropsWithChildren } from "react";
import { enumFeaturesList } from "@coreapp/constants";

type FeatureKey = (typeof enumFeaturesList)[keyof typeof enumFeaturesList];

type UpgradeCardProps = { iconName: IconName; featureKey?: FeatureKey; learnMoreUrl?: string };

const UpgradeCard = ({
  iconName,
  featureKey,
  learnMoreUrl,
  children
}: PropsWithChildren<UpgradeCardProps>) => {
  return (
    <>
      <Flex
        direction={"column"}
        gap={"16px"}
        alignItems={"center"}
        justifyContent={"center"}
        width={"100%"}
      >
        <BigInfoIcon name={iconName} color="brand">
          {children}
        </BigInfoIcon>
        <UpgradeButtons featureKey={featureKey} learnMoreUrl={learnMoreUrl} />
      </Flex>
    </>
  );
};

export default UpgradeCard;
